import React, { useMemo } from 'react';
import classnames from 'classnames';
import Icon from 'components/Icon';

// @label: string | select's label
// @name: string | select's name
// @placeholder: string | select's placeholder
// @value: string | select's value
// @error: string | error's description
// @readOnly: boolean | should be editable?
// @className: string | additional classes
// @children: array | select's options
// @onChange: function | onChange handler
const Select = ({
	label,
	type,
	name,
	placeholder,
	value,
	error,
	readOnly,
	icon,
	className,
	options,
	onChange
}) => {
	// Concat className with modifiers
	const cls = useMemo(() => classnames(
		'input__wrap',
		error && 'input__wrap--error',
		className
	), [
		error,
		className
	]);

	// Handle onchange event before passing data to main component
	// @event: object | native onchange event
	const beforeChange = event => {
		switch(type) {
		case 'number':
			return onChange({
				name,
				value: parseInt(event.target.value) || undefined
			});
		default: {
			return onChange({
				name,
				value: event.target.value
			});
		}
		}
	};

	return (
		<div className="form__element">
			{/* Render label only if it has been passed */}
			{label && <label className="form__label">{label}</label>}

			<div className={cls}>
				{/* Render icon only if it has been passed */}
				{icon && <Icon icon={icon} className="input__icon" />}

				<select
					itemType="number"
					name={name}
					value={value}
					className="select"
					disabled={readOnly}
					onChange={beforeChange}
				>
					<option key="" value="">{placeholder}</option>
					{options?.map(({ value, text }) =>
						<option key={value} value={value}>{text}</option>
					)}
				</select>

				{/* Render error only if it has been passed */}
				{error && <Icon icon="help_outline" className="error__icon" />}
			</div>
		</div>
	);
};

export default Select;
